// extracted by mini-css-extract-plugin
export default {"burger-menu-list":"burger-nav-list_burger-menu-list__nCsyZ"};